import { render, staticRenderFns } from "./lyric-window.vue?vue&type=template&id=163aff09&"
import script from "./lyric-window.vue?vue&type=script&lang=js&"
export * from "./lyric-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports